module.exports = __webpack_public_path__ + "img/20230928_160651.607cd48c.png";